// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gauge-card_BDT{
    /* background-color: rgb(192, 76, 76) !important; */
}

`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/BatteryDigitalTwin_Bus/GaugeChart.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;AACvD","sourcesContent":[".gauge-card_BDT{\n    /* background-color: rgb(192, 76, 76) !important; */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
